(function () {
  const WEBHOOK_URL = 'https://hook.eu1.make.com/ijs5lmnv1qhbvasutcc7yn7zlpoyehxm';

  function validPhone(phone) {
    return phone.replace(/[^\d+]/g, '').length >= 8;
  }

  function initQuickNotify(block) {
    if (!block || block.dataset.quickNotifyInit === '1') return;
    block.dataset.quickNotifyInit = '1';

    const buttons = block.querySelectorAll('[data-quick-notify-variant]');
    const form = block.querySelector('[data-quick-notify-form]');
    const phone = form?.querySelector('input[name="phone"]');
    const submit = form?.querySelector('[data-quick-notify-submit]');
    const submitText = form?.querySelector('.quick-notify__submit-text');
    const errorBox = block.querySelector('[data-quick-notify-error]');
    const errorText = block.querySelector('[data-quick-notify-error-text]');
    const successBox = block.querySelector('[data-quick-notify-success]');

    if (!form) return;

    function clearMessages() {
      if (errorBox) errorBox.hidden = true;
      if (successBox) successBox.hidden = true;
    }

    function setSelected(button) {
      buttons.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      form.querySelector('[name="variant_id"]').value = button.dataset.variantId || '';
      form.querySelector('[name="variant_title"]').value = button.dataset.variantTitle || '';
      form.querySelector('[name="size"]').value = button.dataset.size || '';
      form.querySelector('[name="color"]').value = button.dataset.color || '';
      form.querySelector('[name="sku"]').value = button.dataset.sku || '';
    }

    function showError(message) {
      if (errorText) errorText.textContent = message;
      if (errorBox) errorBox.hidden = false;
      if (successBox) successBox.hidden = true;
    }

    function setLoading(isLoading) {
      if (!submit || !submitText) return;
      submit.disabled = isLoading;
      submit.classList.toggle('is-loading', isLoading);
      submitText.textContent = isLoading ? 'Saving...' : 'Save my request';
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        clearMessages();
        setSelected(button);
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopPropagation();
      clearMessages();

      const phoneVal = phone?.value?.trim() || '';
      const variantId = form.querySelector('[name="variant_id"]').value;

      if (!variantId) {
        showError('Please select a size first.');
        return;
      }

      if (!phoneVal) {
        showError('Please enter your phone number.');
        phone?.focus();
        return;
      }

      if (!validPhone(phoneVal)) {
        showError('Please enter a valid phone number.');
        phone?.focus();
        return;
      }

      const payload = {
        phone: phoneVal,
        product_name: form.querySelector('[name="product_name"]').value,
        product_id: form.querySelector('[name="product_id"]').value,
        variant_id: form.querySelector('[name="variant_id"]').value,
        variant_title: form.querySelector('[name="variant_title"]').value,
        size: form.querySelector('[name="size"]').value,
        color: form.querySelector('[name="color"]').value,
        sku: form.querySelector('[name="sku"]').value,
        product_url: form.querySelector('[name="product_url"]').value,
        handle: form.querySelector('[name="handle"]').value,
        submitted_at: new Date().toISOString()
      };

      try {
        setLoading(true);

        const response = await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        form.reset();
        buttons.forEach((btn) => btn.classList.remove('is-active'));
        if (successBox) successBox.hidden = false;
      } catch (error) {
        console.error('Quick notify submission failed:', error);
        showError('Something went wrong while saving your request. Please try again.');
      } finally {
        setLoading(false);
      }
    });
  }

  function initAllQuickNotify() {
    document.querySelectorAll('[data-quick-notify]').forEach(initQuickNotify);
  }

  document.addEventListener('DOMContentLoaded', initAllQuickNotify);

  const observer = new MutationObserver(() => {
    initAllQuickNotify();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();